var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "conteneurLead",
      staticStyle: { width: "100%" },
      attrs: { flat: "", id: "conteneurLead" }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("justCloseDialog")
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "title tf_title_dialog",
            domProps: { innerHTML: _vm._s(_vm.titleDialog) }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.smAndDown
            ? _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.submitDialog()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
            _c(
              "form",
              { ref: "form" },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("v-flex", { attrs: { xs12: "" } }, [
                      _c("label", { staticClass: "file-select" }, [
                        _c("div", { staticClass: "select-button" }, [
                          _vm.file.name
                            ? _c(
                                "span",
                                {
                                  staticClass: "font-weight-medium subheading"
                                },
                                [_vm._v("Fichier : " + _vm._s(_vm.file.name))]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass: "font-weight-medium subheading"
                                },
                                [_vm._v("Choisissez un fichier")]
                              )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "file", id: "file" },
                          on: {
                            change: function($event) {
                              return _vm.handleFileUpload($event)
                            }
                          }
                        })
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.file && _vm.fileType == "txt"
                  ? _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("AIBaliseDecoup")) +
                                "\n              "
                            ),
                            _c("v-text-field", {
                              attrs: { label: this.$t("AIBalise"), solo: "" },
                              model: {
                                value: _vm.chunkTag,
                                callback: function($$v) {
                                  _vm.chunkTag = $$v
                                },
                                expression: "chunkTag"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm.file && _vm.fileType == "pdf"
                  ? _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", md12: "" } },
                          [
                            _c("v-switch", {
                              attrs: {
                                label: "Résumé : " + _vm.resumePDF.toString()
                              },
                              model: {
                                value: _vm.resumePDF,
                                callback: function($$v) {
                                  _vm.resumePDF = $$v
                                },
                                expression: "resumePDF"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.resumePDF
                          ? _c(
                              "v-flex",
                              { attrs: { xs12: "", md12: "" } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("AINumSeg")) +
                                    " " +
                                    _vm._s(_vm.chunkCar) +
                                    "\n              "
                                ),
                                _c("v-slider", {
                                  attrs: {
                                    max: _vm.chunkCarMax,
                                    min: _vm.chunkCarMin,
                                    step: "1000",
                                    "thumb-label": "",
                                    ticks: ""
                                  },
                                  model: {
                                    value: _vm.chunkCar,
                                    callback: function($$v) {
                                      _vm.chunkCar = $$v
                                    },
                                    expression: "chunkCar"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "mt-0",
                                  attrs: {
                                    "hide-details": "",
                                    "single-line": "",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.chunkCar,
                                    callback: function($$v) {
                                      _vm.chunkCar = $$v
                                    },
                                    expression: "chunkCar"
                                  }
                                })
                              ],
                              1
                            )
                          : _c(
                              "v-flex",
                              { attrs: { xs12: "", md12: "" } },
                              [
                                _c("v-textarea", {
                                  attrs: {
                                    "auto-grow": "",
                                    box: "",
                                    name: "input-7-1",
                                    label: "Default style",
                                    hint: "Hint text"
                                  },
                                  model: {
                                    value: _vm.promptResume,
                                    callback: function($$v) {
                                      _vm.promptResume = $$v
                                    },
                                    expression: "promptResume"
                                  }
                                })
                              ],
                              1
                            )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.alertReturn
            ? _c(
                "v-alert",
                { attrs: { outline: "", value: true, type: _vm.alertType } },
                [_vm._v("\n        " + _vm._s(_vm.textReturn) + "\n      ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "" },
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("close")))]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                loading: _vm.loadingFile,
                disabled: _vm.loadingFile || _vm.desabledBTN,
                color: "primary"
              },
              on: {
                click: function($event) {
                  return _vm.saveRedisFile()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("save")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e308fbe", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e308fbe","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzDialogImportPDF.vue
// module id = null
// module chunks = 